export enum MediaCategoryEnum {
  v5 = 6,
  serviceBook = 7,
  walkaroundVideo = 8
}
